import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlarmExclamation } from '@fortawesome/pro-regular-svg-icons';
import styles from './LatePickUpAlert.module.scss';
import React from 'react';

export const LatePickUpAlert: React.FC = () => {
    const icon = (
        <FontAwesomeIcon
            icon={faAlarmExclamation}
            className={styles.icon}
        />
    );

    const content = <div className={styles.content}>Late Check Out</div>;

    return (
        <div className={styles.container}>
            {icon}
            {content}
        </div>
    );
};

export default LatePickUpAlert;
